































import { Vue, Component } from 'vue-property-decorator'

const config = {
  name: 'icon-world-spacing',
  components: {}
}

@Component(config)
export default class IconWordSpacing extends Vue {}
